/*
 *
 * ReceptionDxGrid14691
 *
 */

import {ReceptionDxGrid} from 'pages/Requests/ReceptionView';
import {
    getReceptionAllAndTodayTab,
    receptionAllAndTodayTabFilters,
    receptionAllAndTodayTabOrders,
    vozdvizhenkaAccessLevel,
    vozdvizhenkaAccessLevelColumnFilter,
    WHO_MEETS,
    whoMeetsColumn,
    whoMeetsColumnFilter
} from '../common/dxGridComponents/columns';
import {REQUESTS_WITHOUT_ON_PASS_MAKING_TYPE, ON_CREATE_REQUESTS,} from "domain/Data/Filters/constants";
import {requestAction} from "domain/typeConstants/action";
import {
    acceptActionButtonReception,
    copyActionButton,
    personalDataActionButton,
    rejectActionButtonReception,
    arrivedActionButton,
} from "../common/actionButton";
import {acceptActionItemReception, copyActionItem, rejectActionItemReception} from "../common/actionMenuItem";
import {columnType, requestColumnSizes} from "domain/typeConstants/table";

export class ReceptionDxGrid14691 extends ReceptionDxGrid {
    getFilters() {
        const filters = super.getFilters();
        const {viewName} = this.props;

        if (viewName === 'all' || viewName === 'today') filters.push(REQUESTS_WITHOUT_ON_PASS_MAKING_TYPE);
        if (viewName === 'create') filters.push(ON_CREATE_REQUESTS);
        return filters;
    }

    getColumns() {
        const {viewName} = this.props;
        const columns = super.getColumns();

        if (viewName === 'all' || viewName === 'today') {
            const blackListStyle = {
                style: {color: '#d50000'},
                condition: (value) => value.isBlackList,
            };
            const styles = [blackListStyle];
            return getReceptionAllAndTodayTab(styles);
        }

        columns.push(whoMeetsColumn);
        const _vozdvizhenkaAccessLevel = {
            ...vozdvizhenkaAccessLevel,
            title: viewName === 'property' ? 'Дебаркадер' : 'Доступ'
        }
        columns.push(_vozdvizhenkaAccessLevel);

        columns.push({
            path: 'isAllowProcessPersonalData',
            name: 'isAllowProcessPersonalData',
            title: 'ПД',
            type: columnType.BOOLEAN,
            width: requestColumnSizes.isTrainingPass,
        })
        return columns;
    }

    getGridFilters() {
        const {viewName} = this.props;
        const gridFilters = super.getGridFilters();

        if (viewName === 'all' || viewName === 'today') {
            return receptionAllAndTodayTabFilters;
        }
        gridFilters.push(whoMeetsColumnFilter);
        gridFilters.push(vozdvizhenkaAccessLevelColumnFilter);
        return gridFilters;
    }

    getColumnOrder() {
        const {viewName} = this.props;
        const columnOrder = super.getColumnOrder();

        if (viewName === 'all' || viewName === 'today') {
            return receptionAllAndTodayTabOrders;
        }

        const noteIndex = columnOrder.findIndex((name) => name === 'note');
        columnOrder.splice(noteIndex, 0, WHO_MEETS);

        const parkingPlaceIndex = columnOrder.findIndex((name) => name === 'parkingPlace');
        columnOrder.splice(parkingPlaceIndex, 0, 'vozdvizhenkaAccessLevel');

        columnOrder.push('isAllowProcessPersonalData')
        return columnOrder;
    }

    getActionButtons() {
        const actionButtons = super.getActionButtons();
        const acceptActionButtonIndex = actionButtons.findIndex((actionButton) => actionButton.name === requestAction.ACCEPT);
        actionButtons.splice(acceptActionButtonIndex, 1, acceptActionButtonReception);

        const rejectActionButtonIndex = actionButtons.findIndex((actionButton) => actionButton.name === requestAction.REJECT);
        actionButtons.splice(rejectActionButtonIndex, 1, rejectActionButtonReception);

        const copyActionButtonIndex = actionButtons.findIndex((actionButton) => actionButton.name === requestAction.COPY);
        actionButtons.splice(copyActionButtonIndex, 1, copyActionButton);

        const arrivedActionButtonIndex = actionButtons.findIndex((actionButton) => actionButton.name === requestAction.ARRIVED);
        actionButtons.splice(arrivedActionButtonIndex, 1, arrivedActionButton);

        actionButtons.push(personalDataActionButton);
        return actionButtons;
    }

    getActionMenuItems() {
        const actionMenuItems = super.getActionMenuItems();
        const acceptMenuItemIndex = actionMenuItems.findIndex((menuItem) => menuItem.name === requestAction.ACCEPT);
        actionMenuItems.splice(acceptMenuItemIndex, 1, acceptActionItemReception);

        const rejectMenuItemIndex = actionMenuItems.findIndex((menuItem) => menuItem.name === requestAction.REJECT);
        actionMenuItems.splice(rejectMenuItemIndex, 1, rejectActionItemReception);

        const copyMenuItemIndex = actionMenuItems.findIndex((menuItem) => menuItem.name === requestAction.COPY);
        actionMenuItems.splice(copyMenuItemIndex, 1, copyActionItem);

        return actionMenuItems;
    }

}
